/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/organisation-member.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { OrganisationMemberAuditFields } from 'queries/generated/fragments.generated';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const OrganisationMemberRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    let refactoredOldRecord = { ...oldRecord };
    let refactoredNewRecord = { ...newRecord };

    if (refactoredOldRecord.hasOwnProperty('IsAdmin'))
        refactoredOldRecord = {
            ...refactoredOldRecord,
            IsOrgAdmin: refactoredOldRecord.IsAdmin,
            IsAdmin: undefined,
        };

    if (refactoredNewRecord.hasOwnProperty('IsAdmin'))
        refactoredNewRecord = {
            ...refactoredNewRecord,
            IsOrgAdmin: refactoredNewRecord.IsAdmin,
            IsAdmin: undefined,
        };

    const enums: any = {
        Status: AuditEnumValues.OrganisationMemberStatus,
    };

    const lookups: any = {
        RoleId: (member: OrganisationMemberAuditFields) => member?.role?.name,
        DefaultStudyId: (member: OrganisationMemberAuditFields) =>
            member?.defaultStudy?.studyNumber ?? member?.defaultStudy?.shortName,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            lookups,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { OrganisationMemberRecordChangeGrid };
